import { lazy } from 'react';

const CalculadorEnganche = lazy(() =>
  import('components/Herramientas/CalculadorEnganche/index').then(module => ({
    default: module.CalculadorEnganche,
  }))
);

const LoanCalculator = lazy(() =>
  import('components/Herramientas/CotizadorCredito/index').then(module => ({
    default: module.LoanCalculator,
  }))
);

const routesHerramientas = [
  {
    path: '/herramientas-calculador-engache',
    name: 'Calculador De Enganche',
    icon: 'nc-icon nc-bank',
    component: <CalculadorEnganche />,
    permissions: ['158_CALCULADOR_DE_ENGANCHE'],
    layout: '/app',
    visibility: true,
    subRoutes: []
  },
  {
    path: '/herramientas-cotizador-credito',
    name: 'Cotizador De Credito',
    icon: 'nc-icon nc-bank',
    component: <LoanCalculator />,
    permissions: ['159_COTIZADOR_DE_CREDITO'],
    layout: '/app',
    visibility: true,
    subRoutes: []
  }
]

export {
  routesHerramientas
}